<!--
component: BrowseKyoai
author: Ken Nakamura
description: 狭あい道路実測図閲覧画面
-->
<template>
  <section class="browse-narrow-road">
    <v-container fluid >
      <v-row>
      <div class="split">
        <div class="split left-box">
          <v-container fluid>
            <v-row>
              <ZoomCanvas id="zoom-area" width="300" heigth="200"
                style="margin:5px;"
                :sourceImage="image" :zoom="zoomScale"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-if="useCanvas"
              />
              <ZoomImageViewer id="zoom-area" width="300" height="200"
                :imageUrl="imageUrl" :sourceWidth="imageWidth" :sourceHeight="imageHeight"
                :zoom="zoomScale" :targetViewId="targetViewId"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-else
              />
            </v-row>
            <v-row>
              <v-col v-for="(page, index) in pages" :key="index"
                cols="12" style="margin:0; padding:0;">
                <v-btn
                  @click="showPage(index)"
                  large width="95%"
                  class="lighten-3 text-h6 ml-1 my-2 blue"
                  :class="{yellow: pageNo==index}" >
                  {{ page.title }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="mt-3 mb-1">
              <v-col cols=6>
              <v-btn @click="zoomIn()"
                light large
                class="text-h5 mx-1 my-3">
                <v-icon color="#55aaff" class="ma-auto">mdi-plus-circle</v-icon>
                拡大
              </v-btn>
              </v-col>
              <v-col>
              <v-btn @click="zoomOut()"
                light large
                class="text-h5 mx-1 my-3">
                <v-icon color="#ccaa55" class="ma-auto">mdi-minus-circle</v-icon>
                縮小
              </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols=12>
                <v-btn @click="printKyoai()"
                  dark color="#bb5577" x-large width="90%"
                  class="text-h5 mx-2 mt-2 mb-1">
                  <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
                  印刷
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="split right-box">
          <ImageCanvas id="image-viewer"
            width="100%" height="100%"
            :imageUrl="imageUrl"
            :imageScale="imageScale"
            :frameVisible="frameVisible"
            :framePos="frameInfo"
            :mouseClick="onImageClick"
            :descText="description"
            @loaded="imageLoaded"
            @scaleChanged="imageScaleChanged"
            @imgMoved="imageMoved"
            @frameMoved="frameMoved"
            v-if="useCanvas"
          />
          <ImageViewer id="image-viewer" :imageUrl="imageUrl"
            :scaleSize="scaleSizeReset"
            :mouseClick="onImageClick"
            :descText="description"
            @updateScaleSize="scaleSize = $event"
            @imgMoved="imageMoved" @imgLoaded="imageLoaded"
            width="100%" height="100%"
            v-else/>
        </div>
      </div>
      </v-row>
      <Dialog search :open="searching" :cancel="cancelSearch" title="狭あい道路検索中" />
      <Dialog message :open="canceled" :ok="()=>{canceled=false;$router.back()}"
        title="狭あい道路検索" body="キャンセルされました" />
			<Dialog error :open="notfound" :ok="back"
        title="狭あい道路"
        body="狭あい道路敷実測図データがありません。"/>
    </v-container>
  </section>
</template>

<script>
import ImageViewer from '../components/ImageViewer.vue';
import ZoomImageViewer from '../components/ZoomImageViewer.vue'
import ImageCanvas from '../components/ImageCanvas.vue';
import ZoomCanvas from '../components/ZoomCanvas.vue';
import { loadKyoai } from '../common/apiAccess';
import Dialog from '../components/Dialog.vue'

export default {
  components: {
    ImageViewer,
    ZoomImageViewer,
    ImageCanvas,
    ZoomCanvas,
		Dialog,
  },
  data: () => {
    return {
      useCanvas: true,
      // TEST モード（Fetch 後に URL を固定のサンプルへ上書き）
      // 運用: true=テスト画像で表示（どのクエリでも固定画像に差し替え）/ false=通常表示
      // - true のときも API の Fetch は行い、受け取った pages をサンプル URL で上書きします
      // - 画像の存在確認を行い、順に拡張子を切替（.png → .tif → .tiff → /accept_info/sample.png）
      // - `public/connections.json` の kyoaiImgOrigin がベース URL です
      testMode: false,
      //printDesc: false,
      pages: [],
      pageNo: 0,
      scaleSize: 1,
      searching: false,
      canceled: false,
      notfound: false,
      controller: null,
      image: null,    // オリジナル画像オブジェクト
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      imgX: 0,        // ImageViewerのimg要素左位置
      imgY: 0,        // ImageViewerのimg要素上位置
      cursorX: 0,     // ImageViewer画像上のマウスカーソルX座標
      cursorY: 0,     // ImageViewer画像上のマウスカーソYX座標
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
      imageScale: 1,  // ImageCanvasに渡す画像拡大率（画面横幅いっぱいを1とする）
      frameVisible: false, // A3印刷枠表示
      frameInfo: null,
      frameX: 0,
      frameY: 0,
      description: [
        '※狭あい協議の申請範囲に基づいた、狭あい道路の中心線及び後退線の考え方を示す図面です。土地の境界を示す図面ではありません。',
        '※道路中心線は今後の道路査定等の状況により変わる可能性があります。',
        '※データ処理の過程により、図面に記載の縮尺と一致しない場合があります。',
      ],
    }
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    ukeNo: {
      type: String,
      default: '',
    },
    zoomRatio: {
      type: Number,
      default: 2,
    },
    zoomOnMove: {
      type: Boolean,
      default: false,
    },
    /*
    printDesc: {
      type: Boolean,
      default: true,
    },
    */
  },
  watch: {
    scaleSize: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
        this.zoomCenterX = this.cursorX;
        this.zoomCenterY = this.cursorY;
      }
    },
    imageScale: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }

    const imgviewer = document.getElementById('image-viewer');
    const zoomimg = document.getElementById('zoom-area');
    this.viewerRatio = imgviewer.offsetWidth / zoomimg.offsetWidth;
    if (this.useCanvas) {
      this.zoomScale = this.imageScale * this.viewerRatio * this.zoomRatio;
    }
    else {
      this.zoomScale = this.scaleSize * this.viewerRatio * this.zoomRatio;
    }

    if (this.id) {
      this.$store.commit('setGaiyoId', this.id);
    }
    else {
      this.frameInfo = this.$store.state.frameInfo;
      this.frameVisible = this.frameInfo.visible;
      this.frameX = this.frameInfo.x;
      this.frameY = this.frameInfo.y;
    }
    this.searching = true;
    this.controller = loadKyoai(this.$store.state.gaiyoId, (data) => {
      this.searching = false;
      if (data && data.images) {
        this.message = `狭あい道路受付番号 : ${data.ukeNo}`;
        if (data.images.length == 0) {
          this.notfound = true;
          this.pages = [];
        }
        else {
          this.pages = data.images;
        }
      }
      // TEST モード: 受け取った FilingLink を固定 URL に差し替える
      // 使い方: data().testMode を true にすると、検索結果に関係なく固定のテスト画像を表示します。
      // - false: 通常運用。API から受け取った images をそのまま表示
      // - true:  API から受け取った images の URL をサンプル URL に上書き（空配列でもサンプル1枚を表示）
      // 注意: ベース URL は store.state.kyoaiImgOrigin（connections.json で設定）。
      //       日本語パスのため encodeURI を使用。拡張子のフォールバックも実施。
      if (this.testMode === true) {
        console.log('[BrowseKyoai] TEST mode: 取得画像 URL をサンプルに差し替え');
        const candidates = [
          encodeURI(`${this.$store.state.kyoaiImgOrigin}/旭/H.29_旭/1.png`),
          encodeURI(`${this.$store.state.kyoaiImgOrigin}/旭/H.29_旭/1.tif`),
          encodeURI(`${this.$store.state.kyoaiImgOrigin}/旭/H.29_旭/1.tiff`),
          '/accept_info/sample.png',
        ];
        const tryLoad = (index) => {
          if (index >= candidates.length) {
            console.warn('[BrowseKyoai] 全候補URLの読み込みに失敗しました');
            this.notfound = true;
            return;
          }
          const url = candidates[index];
          console.log('[BrowseKyoai] 試行URL:', url);
          const img = new Image();
          img.onload = () => {
            console.log('[BrowseKyoai] 読み込み成功:', url);
            if (this.pages && this.pages.length > 0) {
              this.pages = this.pages.map(p => ({ title: p.title || 'サンプル画像', url }));
            } else {
              this.pages = [{ title: 'サンプル画像', url }];
            }
            this.notfound = false;
            this.pageNo = 0;
            this.message = 'サンプル表示モード';
          };
          img.onerror = () => {
            console.warn('[BrowseKyoai] 読み込み失敗:', url);
            tryLoad(index + 1);
          };
          img.src = url;
        };
        tryLoad(0);
      }
    });
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token == undefined || this.token == null || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    imageUrl () {
      if (this.pages === null || this.pages.length === undefined || this.pages.length == 0 || this.pageNo < 0) {
        return '';
      }
      else {
        const page = this.pages[this.pageNo];
        return page.url;
      }
    },
    scaleSizeReset() {
      return this.scaleSize;
    },
    targetViewId() {
      return this.useCanvas ? 'canvas' : 'img';
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
    printDesc() {
      return this.$store.state.kyoaiPrintDesc;
    },
  },
  methods: {
    showPage (no) {
      this.pageNo = no;
      this.scaleSize = 1;
    },
    zoomIn () {
      if(this.scaleSize < 10){
        this.scaleSize += 1;
      }
      this.imageScale *= 1.5;
    },
    zoomOut () {
      if(this.scaleSize > 1){
        this.scaleSize -= 1;
      }
      if (this.imageScale > 1) {
        this.imageScale = Math.max(1, this.imageScale / 1.5);
      }
    },
    printKyoai () {
      this.$store.commit('setFrameInfo', {
        visible: this.frameVisible,
        x: this.frameX,
        y: this.frameY,
      });
      if (this.frameVisible) {
        const images = [{
          image: this.image,
          zoom: 1,
          centerx: this.frameX,
          centery: this.frameY,
        }];
        this.$router.push({name:'print-image',
          params:{useCanvas:true, images:images, paper:'A3R'}});
      }
      else {
        const images = [ this.imageUrl ];
        const desc = this.printDesc ? this.description : null;
        this.$router.push({name:'print-image', useCanvas:false,
          params:{images:images, paper:'A3R', descText: desc}});
      }
    },
    cancelSearch() {
      this.controller.abort();
      this.searching = false;
      this.canceled = true;
    },
    back() {
      this.$router.back();
    },
    imageLoaded(param) {
      if (param) {
        if (this.useCanvas) {
          this.image = param;
          this.imageWidth = param.width;
          this.imageHeight = param.height;
          this.imageScale = 1;
        }
        else {
          this.imageWidth = param.srcw;
          this.imageHeight = param.srch;
        }
      }
    },
    imageMoved(param) {
      this.imgX = param.x;
      this.imgY = param.y;
    },
    imageScaleChanged(scale) {
      this.imageScale = scale;
    },
    frameMoved(param) {
      this.frameX = param.x;
      this.frameY = param.y;
    },
    mouseMove(param) {
      this.cursorX = param.x;
      this.cursorY = param.y;
      if (this.zoomOnMove) {
        this.zoomCenterX = param.x;
        this.zoomCenterY = param.y;
      }
    },
    onImageClick(x, y) {
      if (this.useCanvas) {
        this.zoomCenterX = x;
        this.zoomCenterY = y;
      }
      else {
        this.zoomCenterX = x;
        this.zoomCenterY = y + 55;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.split {
  position: absolute;
  width: 100%;
  height: calc(100% - 4px);
  padding: 0;
  margin: 0;
}
.left-box {
  left: 0;
  width: 320px;
  height: calc(100% - 16px);
  padding: 0.3em;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: calc(100% - 320px);
  height: calc(100% - 16px);
  padding: 0;
  overflow: hidden;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
#zoom-area {
  width: 300px !important;
  height: 200px !important;
  background-color: white;
	overflow: hidden;
}
@media print {
  .left-box {
    visibility: hidden;
    width: 0%;
  }
  .right-box {
    width: 100%;
    overflow-y: auto;
  }
}

</style>